<template>
  <div class="theme-collection-container white-box col-12" v-if="checkExpireDate()">

    <div class="row text-center">
      <div class="col-12 no-pad-both">
        <h2 class="theme-headline">
          <router-link :to="'/group/'+themeData.id" aria-label="">{{ themeData.title }}</router-link>
          <span class="material-icons headline-icon" aria-hidden="true">chevron_right</span>
        </h2>
      </div>
    </div>

    <ul class="row">
      <template v-for="(r, index) in (renderLimit || lengthOfChildren)">
        <ThemeChild :childData="themeData.children[index]" :tagList="tagList" :searchDataExpanded="searchDataExpanded" :key="index" v-if="themeData.children[index]"></ThemeChild>
      </template>
    </ul>

    <div class="row show-more" v-show="lengthOfChildren > 6">
      <div class="col-12">
        <button :aria-label="'Vis alle emner for '+ themeData.title" @click="showAllThemeChildren" v-if="renderLimit" tabindex="0">
          Vis alle
          <span aria-hidden="true" class="material-icons">keyboard_arrow_down</span>
        </button>
        <button :aria-label="'Vis færre emner for '+ themeData.title" @click="showAllThemeChildren" v-else tabindex="0">
          Vis færre
          <span class="material-icons" aria-hidden="true">keyboard_arrow_up</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import ThemeChild from '@/components/ThemeChild.vue'
import Dato from '@/assets/Dato.js'

export default {
  data() {
    return {
      renderLimit: 6,
      lengthOfChildren: false,
    }
  },
  components: {
    ThemeChild,
  },
  props: {
    themeData: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object
    },
    searchDataExpanded: {
      type: Array
    }
  },
  created() {
    if(this.$DeviceCheck.isMobile) {
      this.renderLimit = 4;
    }
    if(this.$props.themeData.children.length == undefined) {
      this.lengthOfChildren = Object.keys(this.$props.themeData.children).length;
    }
    else {
      this.lengthOfChildren = this.$props.themeData.children.length;
    }
  },
  methods: {
    showAllThemeChildren() {
      if(!this.renderLimit) {
        this.renderLimit = (this.$DeviceCheck.isMobile) ? 4 : 6;
      }
      else {
        this.renderLimit = false;
      }
    },
    checkExpireDate() {
      var expired = false;
			if(this.themeData.endDate != false) {
				var itemExpired = Dato.checkExpireDate(this.themeData);
				if(itemExpired) {
					expired = false;
				}
				else {
					expired = true;
				}
			}
      return !expired;
    },
  },
}
</script>

<style lang="scss" scoped>
.theme-collection-container ul {
  margin-bottom: 0px;
}

/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	.theme-collection-container {
		margin-bottom: 20px;
	}
}
/*Landscape - LG*/
@media screen and (min-width: 1200px) and (orientation: landscape) {
	.theme-collection-container {
		margin-bottom: 20px;
	}
}
/*Portrait - XS*/
@media screen and (max-width: 767px) and (orientation: portrait) {
	.theme-collection-container {
		margin-bottom: 10px;
	}
}
/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
	.theme-collection-container {
		margin-bottom: 10px;
	}
}

.theme-headline {
	margin: 5px 0px;
	line-height: 35px;
	vertical-align: middle;
	font-size: 20px;
	text-transform: uppercase;
	color: rgb(000,112,141);
}

.theme-headline a:visited {
	color: rgb(000,112,141);
}

.headline-icon {
	position: relative;
	bottom: -7px;
	font-size: 35px;
}

.show-more {
	height: 25px;
	line-height: 25px;
	font-size: 15px;
	vertical-align: middle;
  text-align: center;
	margin-bottom: 20px;
	color: rgb(000,112,141);
}

.show-more button {
  border: none;
  background-color: unset;
}

.show-more .material-icons {
	vertical-align: middle;
}

@media screen and (max-width: 767px) {
	.show-more {
		margin-top: 10px;
	}
}
@media screen and (min-width: 768px) and (orientation: landscape) {
	.show-more {
		margin-bottom: 10px;
	}
}
@media screen and (min-width: 992px) and (orientation: portrait) {
	.show-more {
		margin-bottom: 10px;
	}
}

</style>
